import axios from "axios";
import { API_URL } from "./const";

export const fetchSocialMedias = async () => {
  return axios
    .get(`${API_URL}/coworking/social-media`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(error.message);
    });
};

export const deleteSocialMedia = async (id) => {
  return axios
    .delete(`${API_URL}/coworking/social-media/${id}`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(error.message);
    });
};

export const addSocialMedia = async (data) => {
  return axios
    .post(`${API_URL}/coworking/social-media`, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(error.message);
    });
};

export const getSocialMedia = async (id) => {
  try {
    const response = await axios.get(`${API_URL}/coworking/social-media/${id}`);
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const editSocialMedia = async (id, data) => {
  try {
    const response = await axios.put(`${API_URL}/coworking/social-media/${id}`, data);
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};
